import React from "react";

const Screenshot = ({ image, priority = false }) => (
  <figure className={`creative-screenshot ${image.height > image.width ? "is-portrait" : "is-landscape"}`}>
    <img
      src={image.src}
      width={image.width}
      height={image.height}
      alt={image.alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
    />
    <figcaption>{image.caption}</figcaption>
  </figure>
);

export function PortfolioVisual({ study, compact = false }) {
  const screenshots = compact
    ? study.cardScreenshots
        .map((id) => study.screenshots.find((image) => image.id === id))
        .filter(Boolean)
    : study.screenshots;

  return (
    <div className={`creative-visual creative-visual--screenshots ${compact ? "is-compact" : "is-gallery"}`}>
      {study.mediaNotice && <p className="creative-media-notice">{study.mediaNotice}</p>}
      <div className="creative-screenshot-grid">
        {screenshots.map((image, index) => (
          <Screenshot image={image} priority={compact && index === 0} key={image.id} />
        ))}
      </div>
    </div>
  );
}
